export default __webpack_public_path__ + "static/media/dropzoneIcon.ce906869.svg";